import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import BottomButtons from '@/ui/modal/bottom-buttons/BottomButtons';
import ClientController from '@/services/ClientController';
import { Trash } from '@/shared/svgs';
import { checkPhoneSoft, checkForeignPhone } from '@/utils/validation';
import useStore from '@/store/store';
import useWindowSize from '@/utils/useWindowSize';
import Checkbox from '@/ui/checkbox/Checkbox';
import { transformPhoneSoft } from '@/utils/funcs';
import { FloatingTextinput } from '@/ui/floating-textinput/floating-textinput';
import { ClientAddresses } from './Client-Addresses';
import { ChevronLeft } from 'lucide-react';
import { useIsMobile } from '@/utils/useIsMobile';
import s from './client.module.css';

const emptyAddress = {
	s: '',
	f: '',
	d: '',
};

const Client = ({ client, initPhone, onClose, onClientSelect, onSuccessEditCb }) => {
	const [a, setA] = useState(client?.a || []);

	const [clientName, setClientName] = useState(client?.f || '');
	const [clientPhone, setClientPhone] = useState(initPhone || client?.phone || client?.p || '');

	const [addressMode, setAddressMode] = useState('new');
	const [selectedAddress, setSelectedAddress] = useState(null);
	const [selectedAddressIndex, setSelectedAddressIndex] = useState(-1);

	const [fp, setFp] = useState(client?.fp === undefined ? false : client?.fp);

	const { user } = useStore();

	const size = useWindowSize();

	const [errorFirstname, setErrorFirstname] = useState(false);
	const [errorPhone, setErrorPhone] = useState(false);
	// const [errorAddress, setErrorAddress] = useState(false);

	// const [errorMapAddress, setErrorMapAddress] = useState(undefined);

	// const [suggestions, setSuggestions] = useState([]);
	// const { getValues, setValue, control, watch } = useForm();
	// // const watchedValue = watch('selectedAddress.s');
	// const debouncedClientSearchText = useDebounce(clientS, 1000);
	// const [disableSug, setDisableSug] = useState(true);

	useEffect(function FUNCTION_NAME() {
		validatePhone(null, clientPhone);
	}, []);

	useEffect(() => {
		if (fp || (!fp && clientPhone)) {
			validatePhone(null);
		}
	}, [fp]);

	// useEffect(() => {
	// 	if (selectedAddress) {
	// 		setTimeout(() => {
	// 			setDisableSug(false);
	// 		}, 1200);
	// 	} else {
	// 		setDisableSug(true);
	// 	}
	// }, [selectedAddress]);

	// useEffect(() => {
	// 	setStreet(watchedValue);
	// }, [watchedValue]);

	// useEffect(() => {
	// 	if (client) {
	// 		const { f, a, p, fp } = client;
	// 		setValue('f', f);
	// 		setA(a || []);
	// 		// console.log("eee will set a", a, client);

	// 		setValue('p', p);
	// 		setErrorFirstname(false);
	// 		setErrorAddress(false);
	// 		setErrorPhone(false);

	// 		setFp(fp === undefined ? false : fp);
	// 	}

	// 	if (initPhone) {
	// 		setValue('p', initPhone);
	// 		validatePhone(null, initPhone);
	// 	} else if (client?.phone) {
	// 		setValue('p', client.phone);
	// 		validatePhone(null, client.phone);
	// 	}
	// }, [client]);

	// const lat = user?.cityLocation?.location.lat;
	// const lng = user?.cityLocation?.location.lng;

	const onDelete = async () => {
		const clientId = client.id;

		const res = await ClientController.delete(clientId);

		if (res?.error) {
			//   console.log(res.error);
			toast.error(
				`Κάποιο πρόβλημα προέκυψε${typeof res.error === 'string' || res?.code ? ':' : ''}${
					typeof res.error === 'string' ? ` ${res.error}` : ''
				}${res?.code ? ` (${res.code})` : ''}`,
			);
			return;
		}

		// const newData = { ...data };
		// const newClients = [...data.clients];
		// const idx = newClients.findIndex((it) => it.id === clientId);
		// newClients.splice(idx, 1);
		// newData.clients = newClients;

		toast.success('Ο Πελάτης διαγράφηκε επιτυχώς');
		// mutate(CLIENT_URL, newData, false);
		onClose();
	};

	const onSave = async () => {
		if (saveDisabled()) {
			return;
		}

		// const { f, p } = getValues();

		const clientData = {
			f: clientName,
			a,
			p: transformPhoneSoft(clientPhone),
			fp: fp === undefined ? false : fp,
		};

		let res;

		if (!client) {
			res = await ClientController.add(clientData, user.cityLocation.id);
			if (!res?.error) {
				if (onClientSelect) {
					onClientSelect(res.id, { ...clientData, id: res.id });
				}
				toast.success('Ο Πελάτης προστέθηκε!');

				onClose();
			} else {
				toast.error(
					`Κάποιο πρόβλημα προέκυψε${typeof res.error === 'string' || res?.code ? ':' : ''}${
						typeof res.error === 'string' ? ` ${res.error}` : ''
					}${res?.code ? ` (${res.code})` : ''}`,
				);
			}
		} else {
			res = await ClientController.edit(client.id, clientData);
			if (!res?.error) {
				if (onClientSelect) {
					onClientSelect(client.id, { ...clientData, id: client.id });
				}
				toast.success('Ο Πελάτης τροποποιήθηκε!');
				if (onSuccessEditCb) {
					onSuccessEditCb(clientData, client.id);
				}
				onClose();
			} else {
				toast.error(
					`Κάποιο πρόβλημα προέκυψε${typeof res.error === 'string' || res?.code ? ':' : ''}${
						typeof res.error === 'string' ? ` ${res.error}` : ''
					}${res?.code ? ` (${res.code})` : ''}`,
				);
			}
		}
	};

	const validateFirstname = () => setErrorFirstname(clientName?.length < 1);
	const validatePhone = (_, value) =>
		setErrorPhone(
			fp ? !checkForeignPhone(value || clientPhone) : !checkPhoneSoft(value || clientPhone),
		);
	// const validateMapAddress = () =>
	// 	// console.log(getValues().mapAddress, tempMapLocation) ||
	// 	setErrorMapAddress(mapAddress || !tempMapLocation?.lat);

	const saveDisabled = () => {
		if (
			errorFirstname === undefined ||
			errorPhone === undefined // || errorAddress === undefined
		) {
			return true;
		}
		if (errorFirstname || errorPhone) {
			return true;
		}
		return false;
	};

	// const saveDisabledMap = () => {
	// 	if (errorMapAddress || errorMapAddress === undefined || !pin) {
	// 		return true;
	// 	}
	// 	return false;
	// };

	const addNewAddress = () => {
		// setValue('selectedAddress.s', '');
		// setValue('selectedAddress.d', '');
		// setValue('selectedAddress.f', '');
		// setClientS('');
		// setClientD('');
		// setClientF('');
		// setLocation(null);
		setSelectedAddress({ ...emptyAddress });
		setAddressMode('new');
	};

	const onEditAddress = idx => {
		// setValue('selectedAddress.s', a[idx].s);
		// setValue('selectedAddress.d', a[idx].d);
		// setValue('selectedAddress.f', a[idx].f);

		// console.log(a);
		// setClientS(a[idx].s);
		// setClientD(a[idx].d);
		// setClientF(a[idx].f);

		// // setStreet(a[idx].s);

		// // if (!a?.[idx]?.l) {
		// //   console.log("edo --> ", a);
		// // }
		// setLocation(a[idx].l);
		setSelectedAddress({ ...a[idx] });
		setSelectedAddressIndex(idx);
		setAddressMode('edit');
	};

	const onDeleteAddress = idx => {
		const newAddresses = [...a];
		newAddresses.splice(idx, 1);
		setA(newAddresses);
	};

	const onSaveAddress = address => {
		// console.log("on save address ", location, getValues().selectedAddress);
		// if (!location) {
		// 	setErrorAddress(true);
		// 	return;
		// }

		// const { s, d, f } = getValues().selectedAddress;

		// console.log(addressMode, location?.geometry?.location?.lat());

		const { street, doorbell, floor, location } = address;
		const newAddress = {
			s: street,
			d: doorbell,
			f: floor,
			l: location,
			// l: {
			// 	lat:
			// 		typeof location?.geometry?.location?.lat === 'function'
			// 			? location?.geometry?.location?.lat()
			// 			: location?.geometry?.location?.lat || location?.lat,
			// 	lng:
			// 		typeof location?.geometry?.location?.lng === 'function'
			// 			? location?.geometry?.location?.lng()
			// 			: location?.geometry?.location?.lng || location?.lng,
			// },
		};

		if (addressMode === 'new') {
			// console.log(
			//   location?.geometry?.location?.lat,
			//   typeof location?.geometry?.location?.lat
			// );
			// const newAddress = {
			// 	s: clientS,
			// 	d: clientD,
			// 	f: clientF,
			// 	l: {
			// 		lat:
			// 			typeof location?.geometry?.location?.lat === 'function'
			// 				? location?.geometry?.location?.lat()
			// 				: location?.geometry?.location?.lat || location?.lat,
			// 		lng:
			// 			typeof location?.geometry?.location?.lng === 'function'
			// 				? location?.geometry?.location?.lng()
			// 				: location?.geometry?.location?.lng || location?.lng,
			// 	},
			// };

			// console.log("eee new address", newAddress);
			// console.log("eee A", a);
			setA(state => [...state, newAddress]);
			// const testL =
			//   location?.lat || location?.geometry?.location?.lat || location?.geometry?.location?.lat();
			// if (!testL) {
			// console.log("thema me location ", location);
			// }
			// setSelectedAddress(null);
		} else {
			// const newAddresses = [...a];

			// newAddresses[selectedAddressIndex] = {
			// 	s: clientS,
			// 	d: clientD,
			// 	f: clientF,
			// 	l: {
			// 		lat:
			// 			typeof location?.geometry?.location?.lat === 'function'
			// 				? location?.geometry?.location?.lat()
			// 				: location?.geometry?.location?.lat || location?.lat,
			// 		lng:
			// 			typeof location?.geometry?.location?.lng === 'function'
			// 				? location?.geometry?.location?.lng()
			// 				: location?.geometry?.location?.lng || location?.lng,
			// 	},
			// };
			const newAddresses = [...a];
			newAddresses[selectedAddressIndex] = newAddress;
			setA(newAddresses);
		}

		setSelectedAddress(null);
		setSelectedAddressIndex(-1);

		// setValue('selectedAddress.s', '');
		// setValue('selectedAddress.d', '');
		// setValue('selectedAddress.f', '');

		// setClientS('');
		// setClientD('');
		// setClientF('');

		// setSuggestions([]);

		// setLocation(null);
	};

	// const onSaveMap = () => {
	// 	setDisableSug(true);
	// 	setTimeout(() => {
	// 		setDisableSug(false);
	// 	}, 2_000);

	// 	// const { mapAddress } = getValues();
	// 	setClientS(mapAddress);

	// 	setLocation(tempMapLocation);
	// 	// setValue('selectedAddress.s', mapAddress);
	// 	setClientS(mapAddress);
	// 	setIsMapOpen(false);
	// };

	// useEffect(() => {
	// 	if (!(debouncedClientSearchText?.length > 2)) {
	// 		return;
	// 	}

	// 	getSuggestions(debouncedClientSearchText);
	// }, [debouncedClientSearchText]);

	// const getSuggestions = async input => {
	// 	console.log(input);
	// 	if (disableSug) {
	// 		return;
	// 	}
	// 	try {
	// 		// setValue('selectedAddress.s', input);
	// 		setClientS(input);
	// 		setLocation(null);
	// 		// setStreet(input);
	// 		const res = await profileController.getAutocomplete(input, {
	// 			location: {
	// 				lat,
	// 				lng,
	// 			},
	// 			radius: 20,
	// 		});
	// 		setSuggestions(res?.predictions);
	// 		//   console.log("res from my api", res);
	// 	} catch (err) {
	// 		console.log('get suggestions errr', err);
	// 	}
	// };

	// const getResults = async (prediction, placeId) => {
	// 	try {
	// 		const res = await profileController.geocodeByAddress(placeId);

	// 		if (!res?.results?.length) {
	// 			return;
	// 		}
	// 		const streetParts = prediction.split(',');
	// 		// console.log("streetParts", streetParts);
	// 		let str = '';
	// 		for (let i = 0; i < streetParts.length - 1; i++) {
	// 			//   console.log("streetParts[i]"), streetParts[i];
	// 			str += streetParts[i];
	// 			if (i !== streetParts.length - 2) {
	// 				str += ', ';
	// 			}
	// 		}

	// 		// console.log("v", prediction, str);
	// 		// setStreet(str);
	// 		setClientS(str);
	// 		// setValue("selectedAddress.s", str || value);

	// 		// setValue("name", str || value);

	// 		setLocation(res?.results?.[0]);

	// 		// setErrorName(false);
	// 		setSuggestions([]);
	// 		setErrorAddress(false);
	// 	} catch (err) {
	// 		console.log('get results errr', err);
	// 	}
	// };

	// const openMap = () => {
	// 	// console.log("open map location ", location);
	// 	if (location) {
	// 		// setValue('mapAddress', getValues().selectedAddress.s);
	// 		setMapAddress(selectedAddress?.s || '');
	// 		// setStreet

	// 		setPin({
	// 			dummy: {
	// 				id: -2,
	// 				name: 'Επιλεγμένη τοποθεσία',
	// 				coords: {
	// 					latitude:
	// 						typeof location?.geometry?.location?.lat === 'function'
	// 							? location?.geometry?.location?.lat()
	// 							: location?.geometry?.location?.lat || location.lat,
	// 					longitude:
	// 						typeof location?.geometry?.location?.lng === 'function'
	// 							? location?.geometry?.location?.lng()
	// 							: location?.geometry?.location?.lng || location.lng,
	// 				},
	// 			},
	// 		});
	// 	}

	// 	setIsMapOpen(true);
	// };

	const onBack = () => {
		setSelectedAddress(null);

		// setSuggestions([]);

		// if (isMapOpen) {
		// 	setTempMapLocation(null);
		// 	setValue('mapAddress', '');

		// 	setPin(null);
		// 	setErrorMapAddress(undefined);
		// 	setIsMapOpen(false);
		// } else {
		// 	setSelectedAddress(null);
		// }
	};

	// const changePin = (lat, lng) => {
	// 	// console.log(lat, lng);
	// 	// ITAN 19/11/22
	// 	// const location = {
	// 	//   geometry: {
	// 	//     location: {
	// 	//       lat,
	// 	//       lng,
	// 	//     },
	// 	//   },
	// 	// };
	// 	const location = {
	// 		lat,
	// 		lng,
	// 	};
	// 	setPin({
	// 		dummy: {
	// 			id: -2,
	// 			name: 'Επιλεγμένη τοποθεσία',
	// 			coords: {
	// 				latitude: lat,
	// 				longitude: lng,
	// 			},
	// 		},
	// 	});
	// 	setTempMapLocation(location);
	// 	setErrorAddress(false);
	// };

	const toggleForeignPhone = () => setFp(s => !s);

	const isMobile = useIsMobile();
	return (
		<div className={s.container}>
			{selectedAddress && (
				<div
					className='absolute left-4 cursor-pointer'
					onClick={onBack}
					style={{ top: isMobile ? 0 : 14 }}
				>
					<ChevronLeft size={32} />
				</div>
			)}

			{/* <div className='modal-title'>
				{!selectedAddress
					? `${client ? 'Προβολή' : 'Δημιουργία νέου'} Πελάτη`
					: `${addressMode === 'edit' ? 'Αλλαγή' : 'Δημιουργία νέας'} διεύθυνσης`}
			</div>

			<div className='modal-title-line' /> */}

			{/* ${selectedAddress ? 'modal-main-address' : 'modal-main-client'} */}
			<div className={`min-w-84`}>
				{!selectedAddress ? (
					<>
						{/* <Textinput
							control={control}
							name='f'
							label='Όνοματεπώνυμο'
							onBlur={validateFirstname}
							error={errorFirstname}
							errorText='Το όνομα δεν είναι έγκυρο'
						/> */}

						<FloatingTextinput
							value={clientName}
							label='Όνοματεπώνυμο'
							onChange={e => setClientName(e)}
							onBlur={validateFirstname}
							error={errorFirstname}
							errorText='Το όνομα δεν είναι έγκυρο'
							white
							size='full'
						/>
						{/* 
						<Textinput
							control={control}
							name='p'
							label='Τηλέφωνο'
							onBlur={validatePhone}
							error={errorPhone}
							errorText='Το τηλ. δεν είναι έγκυρο'
						/> */}

						<div className='flex flex-row items-center gap-x-4'>
							<FloatingTextinput
								value={clientPhone}
								label='Τηλέφωνο'
								inputMode='tel'
								onChange={e => setClientPhone(e)}
								onBlur={validatePhone}
								error={errorPhone}
								errorText='Το τηλ. δεν είναι έγκυρο'
								white
							/>

							<div className={s.foreignPhoneContainer}>
								<Checkbox checked={fp} onChange={toggleForeignPhone} label='Εξωτερικού' />
							</div>
						</div>

						<div className={s.addressesLabel}>Διευθύνσεις</div>
						<div className={s.addressesContainer}>
							{a && a.length > 0 ? (
								a.map((it, idx) => (
									<div
										key={'ad' + it.s + it.f}
										className={s.address}
										onClick={() => onEditAddress(idx)}
									>
										<div className={s.addressText}>
											{`${it.s}${it.d ? `, ${it.d}` : ''}${it.f ? `, ${it.f}` : ''}`}
										</div>
										<div>
											<Trash
												onClick={e => {
													e.stopPropagation();
													onDeleteAddress(idx);
												}}
											/>
										</div>
									</div>
								))
							) : (
								<div className={s.noAddresses}>Δεν βρέθηκαν διευθύνσεις...</div>
							)}
							{a?.length < 5 && (
								<div className={s.addNewAddressButton} onClick={addNewAddress}>
									Προσθήκη νέας
								</div>
							)}
						</div>

						<BottomButtons
							onSave={onSave}
							// style={{ marginBottom: 34 }}
							onDelete={
								client && !selectedAddress && (user?.role === 'master' || user?.role === 'admin')
									? onDelete
									: undefined
							}
							// saveDisabled={isMapOpen ? saveDisabledMap() : !selectedAddress ? saveDisabled() : false}
						/>
					</>
				) : (
					// : isMapOpen ? (
					// 	<div className={s.cityLocationContainer}>
					// 		<div className={s.cityLocationMapContainer}>
					// 			<LiveMap
					// 				initLocation={user?.cityLocation?.location}
					// 				positions={pin}
					// 				width={size.width > 860 ? 520 : size.width * 0.83}
					// 				height={340}
					// 				onClick={(lat, lng) => changePin(lat, lng)}
					// 			/>
					// 		</div>
					// 		<Textinput
					// 			control={control}
					// 			name='mapAddress'
					// 			label='Οδός & αριθμός'
					// 			onBlur={validateMapAddress}
					// 			error={errorMapAddress}
					// 			errorText='Η διεύθυνση δεν μπορεί να είναι κενή'
					// 		/>
					// 		<FloatingTextinput
					// 			value={mapAddress}
					// 			label='Οδός & αριθμός'
					// 			onChange={e => setMapAddress(e)}
					// 			white
					// 			onBlur={validateMapAddress}
					// 			error={errorMapAddress}
					// 			errorText='Η διεύθυνση δεν μπορεί να είναι κενή'
					// 		/>
					// 	</div>
					// )
					<>
						{/* <Autocomplete
							suggestions={suggestions}
							getResults={getResults}
							value={street}
							control={control}
							name='selectedAddress.s'
							label='Οδός & αριθμός'
							// onBlur={validateAddress}
							error={errorAddress}
							errorText='Επιλέξτε μία από τις διευθύνσεις του μενού'
						/> */}
						{/* {console.log('street', street)} */}

						<ClientAddresses address={selectedAddress} onSaveAddress={onSaveAddress} />
						{/* <Autocomplete
							// control={control}
							// name='address'
							value={clientS}
							label='Οδός & αριθμός'
							onChange={e => {
								setClientS(e);
								// setMapAddress(e.target.value);
							}}
							suggestions={suggestions}
							getResults={getResults}
							error={errorAddress}
							errorText='Επίλεξε ένα από τα αποτελέσματα'
							size='full'
						/>
						<div className={s.addNewAddressButton} onClick={openMap}>
							Επιλογή με το χέρι στον χάρτη
						</div>

						<Textinput control={control} name='selectedAddress.d' label='Κουδούνι' />
						<FloatingTextinput
							value={clientD}
							label='Κουδούνι'
							onChange={e => setClientD(e)}
							white
						/>
						<Textinput control={control} name='selectedAddress.f' label='Όροφος' />
						<FloatingTextinput value={clientF} label='Όροφος' onChange={e => setClientF(e)} white /> */}
					</>
				)}
			</div>
		</div>
	);
};

export default Client;
